<div [formGroup]="addressFormGroup" *ngIf="!loading" class="field-group-layout">

  <!-- COUNTRY ROW -->
  <soldo-field-layout
    cypressSelector="Address_NgSelect_Country"
    [control]="addressFormGroup.controls.countryISO"
    fieldName="countryISO"
    label="REGISTRATION.ADDRESS.COUNTRY_LABEL">

    @if (readonly || disableCountrySelection) {
      <div input>
        <input type="text" name="country_label" [value]="selectedCountryLabel" readonly />
        <input type="hidden" name="countryISO" [formControl]="addressFormGroup.controls.countryISO" />
      </div>
    } @else {
      <ng-select input
        name="countryISO"
        [formControl]="addressFormGroup.controls.countryISO"
        [items]="countries"
        dropdownposition="bottom"
        notFoundText="{{'NO_ITEMS_FOUND' | translate }}"
        type="search"
        [clearable]=false
        bindLabel="name"
        bindValue="iso3">
      </ng-select>
    }
    <ng-container errorMessage>
      <soldo-field-error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
    </ng-container>

  </soldo-field-layout>

  @switch (selectedCountry) {
    @case ('GBR') {
      <address3-uk
        [addressFormGroup]="addressFormGroup"
        [readonly]="readonly" />
    }
    @case ('IRL') {
      <address3-ireland
        [addressFormGroup]="addressFormGroup"
        [readonly]="readonly" />
    }
    @case ('ITA') {
      <address3-italy
        [addressFormGroup]="addressFormGroup"
        [readonly]="readonly" />
    }
    @case ('USA') {
      <address3-usa
        [addressFormGroup]="addressFormGroup"
        [readonly]="readonly" />
    }
    @default {
      @if(selectedCountry) {
        <address3-default
          [addressFormGroup]="addressFormGroup"
          [readonly]="readonly" />
      }
    }
  }


</div>
